module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-1.6104efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-1.jpg
// module id = Iswt
// module chunks = 1